import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * Heist detail -- `/heists/$heistId`. Page body lazy-loaded.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/heists/$heistId",
	component: lazyRouteComponent(() => import("./$heistId.page")),
})
